"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSelection = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ContactSelection = (function (_super) {
    __extends(ContactSelection, _super);
    function ContactSelection() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.renderBackButton = function () {
            var goBack = _this.props.goBack;
            return (react_1.default.createElement("button", { className: "contact-selection__back-btn", "aria-label": "Go back", onClick: goBack },
                react_1.default.createElement(icons_1.ArrowLeft, null)));
        };
        _this.renderHeading = function () {
            var templateProjectName = _this.props.templateProjectName;
            return react_1.default.createElement("span", { className: "contact-selection__heading" },
                "Creating page from: ",
                templateProjectName);
        };
        _this.renderCreateButton = function () {
            var _a = _this.props, isCreationDisabled = _a.isCreationDisabled, createQwilr = _a.createQwilr;
            return (react_1.default.createElement(kaleidoscope_1.Button, { className: "contact-selection__create-btn", type: kaleidoscope_1.ButtonType.Primary, onClick: createQwilr, disabled: isCreationDisabled }, "Create page"));
        };
        _this.renderContacts = function (contacts) {
            var contactsList = contacts.map(function (template, index) {
                return _this.renderContact(template, index);
            });
            return react_1.default.createElement("div", null, contactsList);
        };
        _this.renderContact = function (contact, index) {
            return (react_1.default.createElement(kaleidoscope_2.UserCard, { className: "space-stack-xs", key: index, user: _this.generateUserFromContact(contact), selected: contact.selected, onClick: _this.generateOnClickFromContact(contact) }));
        };
        _this.generateOnClickFromContact = function (contact) {
            return function () {
                _this.props.onSelectContact(contact);
            };
        };
        _this.generateUserFromContact = function (contact) {
            return {
                firstName: contact.firstName || contact.email || "Contact ID: ".concat(contact.id),
                lastName: contact.lastName,
                email: contact.email,
            };
        };
        return _this;
    }
    ContactSelection.prototype.render = function () {
        var contacts = this.props.contacts;
        return (react_1.default.createElement("div", { className: "hubspot" },
            react_1.default.createElement("div", { className: "contact-selection" },
                react_1.default.createElement("section", { className: "contact-selection__nav-bar" },
                    react_1.default.createElement("div", { className: "contact-selection__nav-bar-content" },
                        this.renderBackButton(),
                        this.renderHeading(),
                        this.renderCreateButton())),
                react_1.default.createElement("section", { className: "contact-selection__body" },
                    react_1.default.createElement("div", { className: "contact-selection__body-content" },
                        react_1.default.createElement("h3", { className: "contact-selection__title" }, "Select a Contact"),
                        react_1.default.createElement("p", { className: "contact-selection__description" }, "This template contains Contact tokens. Please select one Contact to use with this template."),
                        contacts.status === "loading" && this.renderLoading(),
                        contacts.status === "ready" && this.renderContacts(contacts.data),
                        contacts.status === "error" && this.renderError(contacts.message))))));
    };
    ContactSelection.prototype.renderLoading = function () {
        return react_1.default.createElement("div", { className: "contact-selection__loader" });
    };
    ContactSelection.prototype.renderError = function (message) {
        return react_1.default.createElement("div", { className: "contact-selection__error" }, message);
    };
    ContactSelection = __decorate([
        mobx_react_1.observer
    ], ContactSelection);
    return ContactSelection;
}(react_1.default.Component));
exports.ContactSelection = ContactSelection;
